import { render, staticRenderFns } from "./TotalInteractionsPerType.vue?vue&type=template&id=9f20dd5e"
import script from "./TotalInteractionsPerType.vue?vue&type=script&lang=ts"
export * from "./TotalInteractionsPerType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports